var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlayArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 14,
  fill: "none",
  viewBox: "0 0 12 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  stroke: "currentColor",
  d: "M10.406 6.578a.5.5 0 0 1 0 .844L2.268 12.6a.5.5 0 0 1-.768-.421V1.822a.5.5 0 0 1 .768-.422z"
})));
export { SvgPlayArrow as ReactComponent };